import React, { useEffect, useState } from 'react';
import { Navbar, Container, Nav, Row, Col, NavDropdown } from 'react-bootstrap';
import logo from '../../assets/hhie-logo.jpg';
import Image from 'react-bootstrap/Image';
import '../../styles/NavMenu.css';
import TableStats from '../display-members/table/TableStats';

export function NavMenu() {
    const [adminUser, setAdminUser] = useState(false);
    const [userType, setUserType] = useState("");
    const [version, setVersion] = useState("0");
    const [registrationFeature, setRegistrationFeature] = useState(false);

    useEffect(() => {
        fetch('api/admin/GetFeatures')
            .then((response) => {
                response.json()
                    .then((json) => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        for (var i = 0; i < json.message.length; i++) {
                            if (json.message[i].name === "registration") {
                                setRegistrationFeature(json.message[i].value);
                            }
                        }
                    })
                    .catch((error) => {
                        console.log("Retrieve json error: " + error);
                    })
            })
            .catch((error) => {
                console.log("Retrieve response error: " + error);
            });

        const userString = sessionStorage.getItem("user");
        if (userString === null) {
            setAdminUser(false);
        }
        var sfid = "";
        var user = {};
        try {
            user = JSON.parse(userString);
        }
        catch (ex) {
            console.log("JSONParseUser", ex);
        }
        sfid = user.sfid;

        if (!user.isPOCUser) {
            fetch('api/admin/GetHhieUserRoleBySfId/' + sfid + '/' + false)
                .then(response => {
                    response.json()
                        .then(json => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors)
                            if (json.message === true) {
                                setUserType("HHIEUser");
                            }
                        })
                        .catch(ex => {
                            console.log("JSONgetHHIEUserRoleSfId", ex);
                        })
                })
                .catch(ex => {
                    console.log("getHHIEUserRoleSfId", ex);
                });

            fetch('api/admin/GetAdminRoleBySfId/' + sfid)
                .then(response => {
                    response.json()
                        .then(json => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors)
                            setAdminUser(json.message);
                        })
                        .catch(ex => {
                            console.log("jsonAdminUserRoleSfId", ex);
                        })
                })
                .catch(ex => {
                    console.log("AdminUserRoleSfId", ex);
                });
        }
        else {
            setUserType("POCUser");
        }

        fetch('api/pass/version')
            .then((response) => {
                response.json()
                    .then((json) => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        setVersion(json.message.version);
                    })
                    .catch(ex => {
                        console.log("versionJsonEx", ex);
                    })
            })
            .catch(ex => {
                console.log("versionResponseEx", ex);
            })
    }, [])

    return (
        <header>
            <Container className="HHIE-HealtheNet-web-branding">
                <Row>
                    <Col lg={6}>
                        <Image className="nav-logo" src={logo} />
                    </Col>
                </Row>
            </Container>
            <Navbar collapseOnSelect expand='sm' className="navigation-bar" bg="dark" variant="dark">
                {userType === "HHIEUser" ?
                    <Container>
                        <Navbar.Toggle aria-controls='responsive-navbar-nav' />
                        <Navbar.Collapse id='responsive-navbar-nav'>
                            {window.location.href.includes("admin") ?
                                <Navbar.Brand>Admin</Navbar.Brand>
                                :
                                <Navbar.Brand>{window.location.href.includes("members") ? "PASS" : "REG"} System</Navbar.Brand>
                            }
                            <Navbar.Brand style={{ color: 'grey' }}>v{version}</Navbar.Brand>
                            {adminUser &&
                                <Nav activeKey={window.location.pathname} className="mr-auto">
                                    <NavDropdown title="Admin" id="admin-dropdown">
                                        <NavDropdown.Item id="admin-config" eventKey="Config" href="/admin-config">Config</NavDropdown.Item>
                                        <NavDropdown.Item id="admin-roles" eventKey="Roles" href="/admin-roles">Roles</NavDropdown.Item>
                                        <NavDropdown.Item id="admin-features" eventKey="Features" href="/admin-features">Features</NavDropdown.Item>
                                        <NavDropdown.Item id="admin-emails" eventKey="emails" href="/admin-emails">Emails</NavDropdown.Item>
                                    </NavDropdown>
                                </Nav>
                            }
                            <ul className="navbar-nav flex-grow">
                                {registrationFeature ?
                                    <li>
                                        <Nav activeKey={window.location.pathname} className="mr-auto">
                                            <Nav.Link id="nav-orgs-btn" href="/account-dashboard">Organizations</Nav.Link>
                                        </Nav>
                                    </li>
                                    : <></>
                                }
                                <li>
                                    <Nav activeKey={window.location.pathname} className="mr-auto">
                                        <Nav.Link id="nav-members-btn" href="/all-members">Members</Nav.Link>
                                    </Nav>
                                </li>
                                <li>
                                    <NavDropdown title="Statistics" id="stats-dropdown">
                                        <NavDropdown.Item eventKey="Stats" disabled="true"><TableStats /></NavDropdown.Item>
                                    </NavDropdown>
                                </li>
                                <li>
                                    <Nav activeKey={window.location.pathname} className="mr-auto">
                                        <Nav.Link id="nav-logout-btn" href="/logout">logout</Nav.Link>
                                    </Nav>
                                </li>
                            </ul>
                        </Navbar.Collapse>
                    </Container>
                    :
                    <ul className="navbar-nav ml-auto">
                        <li>
                            <Nav activeKey={window.location.pathname} className="mr-auto">
                                <Nav.Link id="nav-logout-btn" href="/logout">logout</Nav.Link>
                            </Nav>
                        </li>
                    </ul>
                }
            </Navbar>
        </header>
    );
}
